export default "__VITE_PUBLIC_ASSET__5f5b155d__"